// SentencePart.tsx

import React from 'react';
import { IonCard, IonCardTitle } from '@ionic/react';
import { displayPic, usePhotoGallery } from './usePhotoGallery';
import { useTreeStore } from './stateManagement/treeZustand';
import { useGlobalStore } from './stateManagement/globalZustand';
import { label2LabelToShow } from '../foo/cards';

interface SentencePartProps {
  label: string;
  position: number;
  onClick: () => void;
  layoutMode: string;  // Added layoutMode to props
}

const SentencePart: React.FC<SentencePartProps> = ({ label, position, onClick, layoutMode }) => {
  const { isParentMode, lang } = useGlobalStore();
  const { takePhoto, photo } = usePhotoGallery();
  const { l2Image, l2Color, path2Params, defaultParams, getImage } = useTreeStore();

  if (isParentMode) {
    return null;
  }

  const cardImg = getImage(label);
  const capitalizeText = path2Params[label]?.capitalizeText || defaultParams.capitalizeText;
  const labelToShow = label2LabelToShow(label, lang, capitalizeText);

  return (
    <div className='container-card-img'>
    <div className='label-container'>{labelToShow}</div>
    <div className='sub-container-card-img'>
          {cardImg ? displayPic(cardImg, isParentMode, false) : photo ? displayPic(photo, isParentMode, false) : null}
    </div>
    </div>
  );
};

export default SentencePart;
